import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";
import { AccessResult, NO_ACCESS_MESSAGE, hasAllRequiredActionsInAnySpace } from "utils/access";
import { Action } from "types/generated";

/**
 * Hook that returns whether current user can create blueprint
 * User needs to be an admin or have SpaceAdmin action in at least one space
 * @returns {AccessResult} Object indicating if user can create blueprint and a message if not
 */
const useCanCreateBlueprint = (): AccessResult => {
  const { viewer } = useTypedContext(AccountContext);

  if (viewer.admin) {
    return { result: true };
  }

  const result = hasAllRequiredActionsInAnySpace([Action.SpaceAdmin], viewer);

  if (result) {
    return { result: true };
  }

  return { result: false, message: NO_ACCESS_MESSAGE };
};

export default useCanCreateBlueprint;
